export type ScriptType = 'script' | 'async_script' | 'sort' | 'operator' | 'validator';

export class ScriptController {
  private scripts: Map<string, any> = new Map();
  private scriptFunctions: Map<string, any> = new Map();
  constructor() {}

  public keys(): any {
    return Array.from(this.scripts.keys());
  }

  public setScript(key: string, script: any): void {
    this.scripts.set(key, script);
  }

  public removeScript(key: string): void {
    this.scripts.delete(key);
  }

  public getScript(key: string): any {
    return this.scripts.get(key);
  }

  public hasScript(key: string): boolean {
    return this.scripts.has(key);
  }

  private getScriptAsFn(key: string, argsAsKeys: string[]): any {
    if (this.scriptFunctions.has(key)) {
      return this.scriptFunctions.get(key);
    }

    const script = this.getScript(key);
    if (!script) {
      throw new Error(`Script ${key} not found`);
    }

    const wrapperScript = this.getWrapperScript(script);

    const fn = new Function('script_type', ...argsAsKeys, wrapperScript);
    this.scriptFunctions.set(key, fn);

    return fn;
  }

  private getWrapperScript(script: string): string {
    const wrapperScript = `
    "use strict";
      ${script}
      `;
    return wrapperScript;
  }

  public executeScript(key: string, type: ScriptType, args: any): any {
    const script = this.getScript(key);
    if (!script) {
      throw new Error(`Script ${key} not found`);
    }

    if (!args.context) {
      args.context = args.options || {};
    }

    const argsAsKeys = Object.keys(args);
    const argsAsArray = Object.values(args);

    const fn = this.getScriptAsFn(key, argsAsKeys);

    return fn(type, ...argsAsArray);
  }
}
